var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor table-create-record" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.createRecordTableId"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-selection-row" },
          [
            _c("CustomPicker", {
              attrs: {
                items: _vm.tables,
                idKey: "_id",
                labelKey: "name",
                title: "Select Table",
              },
              on: { change: _vm.onTableChange },
              model: {
                value: _vm.clone.tableId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tableId", $$v)
                },
                expression: "clone.tableId",
              },
            }),
            _vm._v(" "),
            _vm.clone.tableId
              ? _c(
                  "SupsisButton",
                  {
                    staticClass: "go-to-table-btn",
                    attrs: { ghost: "" },
                    on: { click: _vm.goToTable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("visibility"),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("auto.createRecordTabloyaGit")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.getSelectedTable()
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("auto.createRecordFields"))),
              ]),
              _vm._v(" "),
              _vm._l(_vm.clone.values, function (item, index) {
                return _c(
                  "div",
                  { key: item.fieldId, staticClass: "field-row" },
                  [
                    _c("div", { staticClass: "field-info" }, [
                      _c(
                        "i",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.getFieldTypeTooltip(item.fieldId),
                              },
                              expression:
                                "{ content: getFieldTypeTooltip(item.fieldId) }",
                            },
                          ],
                          staticClass: "material-icons mr-2",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getIcon(item.fieldId)) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-label" }, [
                        _vm._v(_vm._s(_vm.getFieldName(item.fieldId))),
                      ]),
                      _vm._v(" "),
                      ["checkbox", "dropdown"].includes(
                        _vm.getFieldType(item.fieldId)
                      )
                        ? _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "auto.createRecordStaticModeUsePredefinedValues"
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                                Dynamic mode: Use variables or user input\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-switch",
                                    {
                                      attrs: {
                                        checked: item.mode === "static",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onModeChange(index, $event)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "checkedChildren" },
                                          slot: "checkedChildren",
                                        },
                                        [_vm._v("Static")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "unCheckedChildren" },
                                          slot: "unCheckedChildren",
                                        },
                                        [_vm._v("Dynamic")]
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.getFieldType(item.fieldId) === "checkbox" &&
                    item.mode === "static"
                      ? _c("a-checkbox", {
                          attrs: { checked: item.value },
                          on: {
                            change: function ($event) {
                              return _vm.onCheckboxChange(
                                index,
                                $event.target.checked
                              )
                            },
                          },
                        })
                      : _vm.getFieldType(item.fieldId) === "dropdown" &&
                        item.mode === "static"
                      ? _c("CustomPicker", {
                          attrs: {
                            items: _vm.getDropdownOptions(item.fieldId),
                            idKey: "value",
                            labelKey: "value",
                            title: _vm.getFieldName(item.fieldId),
                            multiple: _vm.isDropdownMultiple(item.fieldId),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onDropdownChange(index, $event)
                            },
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        })
                      : _c(
                          "div",
                          { staticClass: "text-editor-wrapper" },
                          [
                            _c("TiptapEditor", {
                              attrs: {
                                placeholder: _vm.getFieldName(item.fieldId),
                                "show-attributes": true,
                                "show-emoji": true,
                                "max-character-count": 1024,
                                "automation-mode": "",
                              },
                              model: {
                                value: _vm.clone.values[index].value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.clone.values[index],
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "clone.values[index].value",
                              },
                            }),
                          ],
                          1
                        ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }